import React from 'react';
import {
  ManagedAccountPageContextProvider,
} from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Context/ManagedAccountPageContext';
import ManagedAccountRefactoredContent
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageContent';

const ManagedAccountRefactoredTemplate = () => {
  return (
    <ManagedAccountPageContextProvider>
      <ManagedAccountRefactoredContent />
    </ManagedAccountPageContextProvider>
  );
};

export default ManagedAccountRefactoredTemplate;
